import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconLeaf20(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={20}
            height={20}
            className={customClassName}
            name="IconLeaf20"
            aria-hidden="true"
            {...props}
        >
            <g fill="none">
                <g clipPath="url(#Leaf20)">
                    <path
                        fill="currentColor"
                        fillRule="evenodd"
                        d="m7.132 11.807-1.055 1.055a4.865 4.865 0 0 1 .49-6.307c.398-.399 1.107-.812 2.097-1.172.964-.35 2.08-.61 3.175-.77 1.098-.162 2.124-.216 2.904-.179.314.015.562.044.745.077.034.183.063.432.078.746.037.78-.018 1.806-.178 2.903-.161 1.096-.42 2.211-.772 3.176-.36.99-.772 1.699-1.17 2.097a4.865 4.865 0 0 1-6.309.49l1.045-1.045h3.444a.75.75 0 0 0 0-1.5H9.682l2.67-2.67a.75.75 0 0 0-1.06-1.06l-2.66 2.659V8.759a.75.75 0 1 0-1.5 0zM5.506 5.494a6.365 6.365 0 0 0-.5 8.439l-1.61 1.61a.75.75 0 1 0 1.061 1.06l1.61-1.61a6.365 6.365 0 0 0 8.439-.5c2.485-2.484 3.117-10.117 2.117-11.117S7.992 3.01 5.506 5.494m10.25-.914-.009-.004zm-.333-.327"
                        clipRule="evenodd"
                    />
                </g>
                <defs>
                    <clipPath id="Leaf20">
                        <path fill="#fff" d="M0 0h20v20H0z" />
                    </clipPath>
                </defs>
            </g>
        </svg>
    );
}
export default memo(IconLeaf20);
